import { createStoreon } from 'storeon';
import { storeonDevtools } from 'storeon/devtools';

import { appStoreModule, IAppEvents, IAppState } from './AppStoreModule';
import { IRoofEvents, IRoofState, roofStoreModule } from './RoofStoreModule';
import { IFenceEvents, IFenceState, fenceStoreModule } from './FenceStoreModule';

export interface IState extends IAppState, IRoofState, IFenceState {}

export interface IEvents extends IAppEvents, IRoofEvents, IFenceEvents {}

export const store = createStoreon<IState, IEvents>([
  appStoreModule,
  roofStoreModule,
  fenceStoreModule,
  storeonDevtools,
]);
